import * as React from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import { format as DateFormat } from "date-fns";
import PropTypes from "prop-types";

const Consulta = (props) => {
  const { datos, ar, open, onClose, onSave } = props;
  return (
    <Dialog open={open} onClose={onClose} size="xs">
      <DialogContent>
        <DialogContentText>
          {datos &&
            ar &&
            "¿Desea " +
              ar +
              ' la solicitud del día "' +
              DateFormat(new Date(datos.Desde), "dd/MM/yyyy") +
              '" de ' +
              datos.NombreConductor +
              "?"}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSave}>Sí</Button>
        <Button onClick={onClose}>No</Button>
      </DialogActions>
    </Dialog>
  );
};
Consulta.propTypes = {
  datos: PropTypes.object,
  ar: PropTypes.oneOf(["aprobar", "rechazar"]),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
export default Consulta;
